import Age from "./Age";

export { Age };
